// Danish display names for ISO-2 country codes used by the geo segmentation features.
const COUNTRY_NAMES_DA: Record<string, string> = {
  DK: 'Danmark', DE: 'Tyskland', SE: 'Sverige', NO: 'Norge', FI: 'Finland',
  NL: 'Holland', BE: 'Belgien', LU: 'Luxembourg', FR: 'Frankrig', ES: 'Spanien',
  PT: 'Portugal', IT: 'Italien', AT: 'Østrig', CH: 'Schweiz', PL: 'Polen',
  CZ: 'Tjekkiet', SK: 'Slovakiet', HU: 'Ungarn', RO: 'Rumænien', BG: 'Bulgarien',
  GR: 'Grækenland', HR: 'Kroatien', SI: 'Slovenien', RS: 'Serbien', BA: 'Bosnien-Hercegovina',
  LT: 'Litauen', LV: 'Letland', EE: 'Estland', GB: 'Storbritannien', IE: 'Irland',
  IS: 'Island', TR: 'Tyrkiet', UA: 'Ukraine', BY: 'Hviderusland', RU: 'Rusland',
  US: 'USA', CN: 'Kina', MK: 'Nordmakedonien', AL: 'Albanien', MD: 'Moldova',
  LI: 'Liechtenstein', MT: 'Malta', CY: 'Cypern',
};

/** Danish name for a country code; falls back to the code/raw text. */
export function countryName(code: string | null | undefined): string {
  if (!code) return '';
  return COUNTRY_NAMES_DA[code.toUpperCase()] ?? code;
}

/** "Danmark (DK)" style label. */
export function countryLabel(code: string | null | undefined): string {
  if (!code) return '';
  const name = COUNTRY_NAMES_DA[code.toUpperCase()];
  return name ? `${name} (${code.toUpperCase()})` : code;
}
